import { Container, Graphics, Text } from 'pixi.js';

import type { GameplaySnapshot } from '../engine/gameplay/GameplayTypes';
import { seasonLabels, weatherLabels, type SeasonState } from '../engine/seasons/SeasonTypes';
import type { KingdomResourceState } from '../engine/world/types';

export class ResourcePanel {
  readonly root = new Container();
  private readonly background = new Graphics();
  private readonly text = new Text({
    text: '',
    style: {
      fill: '#f7d782',
      fontFamily: 'Georgia, serif',
      fontSize: 14,
      lineHeight: 19,
      stroke: { color: '#1b1206', width: 4 },
    },
  });

  constructor() {
    this.root.addChild(this.background, this.text);
    this.root.position.set(28, 28);
    this.text.position.set(14, 10);
    this.background.rect(0, 0, 980, 64).fill({ color: 0x10170c, alpha: 0.84 }).stroke({ color: 0xb8852c, width: 2 });
  }

  setPolishMode(): void {
    this.root.position.set(24, 22);
    this.text.style.fontSize = 13;
    this.text.style.lineHeight = 18;
    this.background.clear();
    this.background.rect(0, 0, 1510, 62).fill({ color: 0x0b1208, alpha: 0.72 }).stroke({ color: 0xc79638, width: 2 });
  }

  update(resources: KingdomResourceState, level: number, season?: SeasonState, gameplay?: GameplaySnapshot): void {
    const seasonText = season
      ? `${weatherLabels[season.currentWeather]} | ${seasonLabels[season.currentSeason]} Tag ${season.seasonDay} | `
      : '';
    const project = gameplay?.community.projects.find((candidate) => !candidate.completed);
    const projectText = project ? ` | Projekt ${project.label} ${Math.round((project.progress / project.goal) * 100)}%` : '';
    const gameplayText = gameplay
      ? ` | ${gameplay.phase} · ${gameplay.population} Einwohner | Zufriedenheit ${resources.satisfaction}% | Verteidigung ${resources.defense} | Forschung ${gameplay.activeResearch[0]?.label ?? 'frei'}${projectText}`
      : '';
    const format = (value: number): string => Math.max(0, Math.floor(value)).toLocaleString('de-DE');
    const stockText = [
      `Holz ${format(resources.wood)}`,
      `Stein ${format(resources.stone)}`,
      `Nahrung ${format(resources.food)}`,
      `Gold ${format(resources.gold)}`,
      `Eisen ${format(resources.iron)}`,
      `Lehm ${format(resources.clay)}`,
      `Werkzeuge ${format(resources.tools)}`,
      `Waffen ${format(resources.weapons)}`,
      `Rüstung ${format(resources.armor)}`,
      `Belagerung ${format(resources.siegeEngines)}`,
      `Ziegel ${format(resources.bricks)}`,
      `Baumaterial ${format(resources.buildingMaterials)}`,
      `Prestige ${format(resources.prestige)}`,
      `Kristalle ${format(resources.crownCrystals)}`,
    ].join(' · ');
    this.text.text = `${seasonText}Stufe ${level}${gameplayText}\n${stockText}`;
  }
}
